import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';

@Component({
  selector: 'app-uploaded-files',
  templateUrl: './uploaded-files.component.html'
})
export class UploadedFilesComponent {

  url: string = "";
  
  constructor( public dialog: MatDialog, 
    @Optional() public dialogRef: MatDialogRef<UploadedFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any ) {}


  ngOnInit(): void {
    this.url = this.data.Url;
  }

  cancel(){
    this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
  }

  openAttachment(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
